module.exports = __webpack_public_path__ + "static/media/chart-hex.20ca438e.svg";